const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.16,
    y: 4.16,
    width: 23.68,
    height: 23.68,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.915,27.84a.925.925,0,0,1-.925-.925,3.323,3.323,0,0,0-3.308-3.33H21.9a3.323,3.323,0,0,0-3.308,3.33.925.925,0,0,1-1.85,0,5.175,5.175,0,0,1,5.158-5.18h.784a5.175,5.175,0,0,1,5.158,5.18.925.925,0,0,1-.925.925Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.244,12.485a3.937,3.937,0,1,0,2.778,1.153A3.929,3.929,0,0,0,22.244,12.485Zm0,6.012a2.083,2.083,0,1,1,1.471-.61A2.089,2.089,0,0,1,22.244,18.5Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89,26.915a.925.925,0,0,0-.925-.925H9.709a3.7,3.7,0,0,1-3.7-3.7V9.709a3.7,3.7,0,0,1,3.7-3.7h8.513a3.7,3.7,0,0,1,3.7,3.7.925.925,0,0,0,1.85,0,5.557,5.557,0,0,0-5.55-5.549H9.709A5.555,5.555,0,0,0,4.16,9.709V22.291A5.555,5.555,0,0,0,9.709,27.84h4.256a.925.925,0,0,0,.925-.925Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.416,14.659a.925.925,0,0,0-.925-.925H10.5a.925.925,0,0,0,0,1.85h4.995a.925.925,0,0,0,.925-.925Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.266,11.1a.925.925,0,0,0-.925-.925H10.5a.925.925,0,0,0,0,1.85h6.845a.925.925,0,0,0,.925-.925Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.416,21.735a.925.925,0,0,0-.925-.925H10.5a.925.925,0,0,0,0,1.85h4.995a.925.925,0,0,0,.925-.925Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.416,18.174a.925.925,0,0,0-.925-.925H10.5a.925.925,0,0,0,0,1.85h4.995a.931.931,0,0,0,.654-.271.92.92,0,0,0,.271-.654Z",
    style: {
      fill: "#49b3b1"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissions);
export default __webpack_public_path__ + "static/media/submissions.090bb1dae6a2eb78fa64c97078630fb0.svg";
export { ForwardRef as ReactComponent };